import React from 'react'
import Image from '../../../images/sellerpolicies/7.png'

const Indemnification = () => {
  return (
    <div className='sp_details_wrapper'>
      <div className='sp_details_container'>
        <div className='sp_details_image'>
            <img src={Image} alt='policy'/>
        </div>
        <div className='sp_details_details'>
            <h2>INDEMNIFICATION</h2>
            <p>The Seller agrees to release, defend, indemnify and hold harmless KAAY, including its affiliates, and any director, officer, employee, contractor, or agent, against any costs (including attorney fees and court costs on an indemnity basis), fines, penalties, damages, and liabilities, arising from, alleged to arise from, or in any way associated with:</p>
            <ul>
                <li>a.	Any defect in Products sold to any Customer;</li>
                <li>b.	Any claim made by any Customer on the basis of any Contract;</li>
                <li>c.	Any defect in the packaging or shipping of a Product by the Seller;</li>
                <li>d.	Any violation of any law committed by the Seller, including any failure by the Seller to pay any required tax on the import, manufacture, production, sale, supply, distribution, or delivery of a Product;</li>
                <li>e.	Any negligence or fault of whatever nature of the Seller or its affiliates, and any director, officer, employee, contractor, or agent; or</li>
                <li>f.	Any breach in any warranty or representation made herein.</li>
            </ul>
        </div>
      </div>
    </div>
  )
}

export default Indemnification
